import React from 'react'
import {Container, Button, Grid, Drawer} from '@material-ui/core'
import {Link} from 'react-router-dom'
import TemplateDrawer from './BarcodeTemplateDrawer'
import {useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'
import useStyles from './BarcodeNavHeaderButtons.styles'

export default function BarcodeNavHeaderButtons(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const [drawerOpen, setDrawerOpen] = React.useState(false)
  const history = useHistory()

  function chooseTemplateBtn(event) {
    setDrawerOpen(true)
  }

  const toggleDrawer = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setDrawerOpen(open)
  }

  return (
    <div>
      <Grid container>
        <Grid container item xs={6} justify="flex-start">
          <Container>
            <Button
              variant="outlined"
              className={classes.buttonLink}
              color="primary"
              onClick={() => (props.previous ? history.push(props.previous) : history.goBack())}
              hidden={!props.previous}
            >
              {t('barcode.wizard.button-links.previous')}
            </Button>
          </Container>
        </Grid>

        <Grid container item xs={6} justify="flex-end">
          <div>
            <Button
              variant="outlined"
              className={classes.buttonLink}
              color="primary"
              onClick={chooseTemplateBtn}
            >
              {t('barcode.wizard.button-links.choose-template')}
            </Button>
            <Button
              variant="outlined"
              className={classes.buttonLink}
              color="primary"
              component={Link}
              to="/barcode-library"
            >
              {t('barcode.wizard.button-links.go-to-library')}
            </Button>
          </div>
        </Grid>
      </Grid>
      <Drawer anchor="right" open={drawerOpen}>
        <TemplateDrawer
          toggleDrawer={toggleDrawer()}
          template={props.template}
          reprint={props.reprint}
        />
      </Drawer>
    </div>
  )
}
